import React from "react";
import { Field, reduxForm } from "redux-form";
import { FormattedMessage } from "react-intl";

import CNBTextArea from "components/CNBTextArea";
import BackgroundBlock from "../../partials/BackgroundBlock";
import ButtonsRow from "../../partials/ButtonsRow";
import Validations from "helpers/validations";

import "./style.scss";

interface IProps {
  invalid: boolean;
  goNext: () => void;
  goBack: () => void;
}

class StepFive extends React.Component<IProps> {
  public render() {
    const { goNext, goBack, invalid } = this.props;

    return (
      <div id="step-five">
        <BackgroundBlock>
          <label className="title">
            <FormattedMessage id="DELIVERIES_COMMENT" />
          </label>
          <Field
            name="comment"
            component={CNBTextArea}
            validate={[Validations.maxLength(250)]}
            rows={5}
          />
          <p className="notes">
            <FormattedMessage id="DELIVERIES_NOTE" />
          </p>
        </BackgroundBlock>
        <ButtonsRow
          goNext={goNext}
          goBack={goBack}
          showBackBtn
          disabled={invalid}
        />
      </div>
    );
  }
}

export default reduxForm({
  form: "delivery",
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(StepFive);
